import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import Utils from "../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Button } from "react-bootstrap";
import Swal from "sweetalert2";

const Skills = () => {

    const [skillsList, setSkillsList] = useState<any[]>([]);
    const [sportList, setSportList] = useState<any[]>([]);
    const [programList, setProgramList] = useState<any[]>([]);
    const [skillId, setSkillId] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [skillName, setSkillName] = useState('');
    const [skillDescription, setSkillDescription] = useState('');
    const [skillSportId, setSkillSportId] = useState('');
    const [skillProgramId, setSkillProgramId] = useState('');
    const [skillOrder, setSkillOrder] = useState('');
    const [skillStatus, setSkillStatus] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        fetchSkills();
    }, [])

        async function fetchSkills() {
            setIsLoading(true);
            const skillResponse = await func.skills(null);
            setSkillsList(Array.isArray(skillResponse) ? skillResponse : [])
            setIsLoading(false);
        }

    const filteredData = skillsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const skillNameRender = (rowData) => {
        return <span>{rowData.skillName}</span>;
    };

    const skillDescriptionRender = (rowData) => {
        return <span>{rowData.skillDescription}</span>;
    };

    const skillSportsNameRender = (rowData) => {
        return <span>{rowData.sportsName}</span>;
    };

    const skillProgramNameRender = (rowData) => {
        return <span>{rowData.programName}</span>;
    };

    const skillStatusRender = (rowData) => {
        return <span>{(rowData.skillStatus == 1) ? "Active" : "Inactive"}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editSkill(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const sklId = rowData.skillId;
        return (
            <Link to="#" onClick={() => deleteSkill(sklId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newSkill() {
        setIsEdit(false)
        setOpenModal(true)
        const sprtResponse = await func.listSports();
        setSportList(Array.isArray(sprtResponse) ? sprtResponse : [])
        const progResponse = await func.program(null);
        setProgramList(Array.isArray(progResponse) ? progResponse : [])
        setSkillName("");
        setSkillDescription("");
        setSkillSportId("");
        setSkillProgramId("");
        setSkillOrder("");
    }


    async function editSkill(rowData: { skillId: any; }) {
        const scdlId = rowData.skillId;
        setIsEdit(true)
        setOpenModal(true)
        const sprtResponse = await func.listSports();
        setSportList(Array.isArray(sprtResponse) ? sprtResponse : [])
        const progResponse = await func.program(null);
        setProgramList(Array.isArray(progResponse) ? progResponse : [])
        const getDetails = await func.skills(scdlId);
        setSkillId(getDetails.skillId);
        setSkillName(getDetails.skillName);
        setSkillDescription(getDetails.skillDescription);
        setSkillSportId(getDetails.skillSportId);
        setSkillProgramId(getDetails.skillProgramId);
        setSkillOrder(getDetails.skillOrder);
        setSkillStatus(getDetails.schedulesStatus);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateSkill();
            } else {
                const formData = new FormData();
                formData.append("skillName", skillName);
                formData.append("skillDescription", skillDescription);
                formData.append("skillSportId", skillSportId);
                formData.append("skillProgramId", skillProgramId);
                formData.append("skillOrder", skillOrder);

                const createSkil = api.Skills;
                fetch(createSkil, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Created',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchSkills();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })

            }
        }
    }

    function updateSkill() {
        const formData = new FormData();
        formData.append("skillName", skillName);
        formData.append("skillDescription", skillDescription);
        formData.append("skillSportId", skillSportId);
        formData.append("skillProgramId", skillProgramId);
        formData.append("skillOrder", skillOrder);
        formData.append("status",skillStatus);

        const updateSkil = api.Skills + '/' + skillId;
        fetch(updateSkil, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchSkills();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deleteSkill(skilId: string) {
        const deleteSkil = api.Skills + '/' + skilId + '/' + 0;
        fetch(deleteSkil, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchSkills();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Skills</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newSkill() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Skill">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="skillName"
                                                header="Skill Name"
                                                body={skillNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="skillDescription"
                                                header="Skill Description"
                                                body={skillDescriptionRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="sportsName"
                                                header="Sports Name"
                                                body={skillSportsNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="programName"
                                                header="Program Name"
                                                body={skillProgramNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="skillStatus"
                                                header="Skill Status"
                                                body={skillStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Skill</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="col-lg-12 mb-10">
                                    <label className="sortbytitle"><h6>Sport</h6></label>
                                    <Select
                                        value={sportList.find(sprt => sprt.sportsId === skillSportId) ? {
                                            value: skillSportId,
                                            label: sportList.find(sprt => sprt.sportsId === skillSportId).sportsName
                                        } : null}
                                        onChange={(e) => {
                                            setSkillSportId(e.value);
                                        }}
                                        required
                                        placeholder="Select Sport"
                                        options={sportList.map(sprt => ({
                                            value: sprt.sportsId,
                                            label: sprt.sportsName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <label className="sortbytitle"><h6>Sport</h6></label>
                                    <Select
                                        value={programList.find(prog => prog.programId === skillProgramId) ? {
                                            value: skillProgramId,
                                            label: programList.find(prog => prog.programId === skillProgramId).programName
                                        } : null}
                                        onChange={(e) => {
                                            setSkillProgramId(e.value);
                                        }}
                                        required
                                        placeholder="Select Program"
                                        options={programList.map(prog => ({
                                            value: prog.programId,
                                            label: prog.programName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Skill Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="skillName"
                                            value={skillName}
                                            onChange={(e) => setSkillName(e.target.value)}
                                            placeholder="Skill Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Skill Description</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="skillDesc"
                                            value={skillDescription}
                                            onChange={(e) => setSkillDescription(e.target.value)}
                                            placeholder="Skill Description" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Skill Order</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="skillOrder"
                                            value={skillOrder}
                                            onChange={(e) => setSkillOrder(e.target.value)}
                                            placeholder="Skill Order" />
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={skillStatus === '1'}
                                                        id="scdlStatus"
                                                        onChange={(e) => {
                                                            setSkillStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
};

export default Skills;